import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter)

import Index from '../pages/index.vue';
import galleryIndex from '../pages/gallery/gallery_index.vue';
import galleryDec from '../pages/gallery/gallery_dec.vue';
import gallery_decTw from '../pages/gallery/gallery_decTw.vue';
import gallery_indexTw from '../pages/gallery/gallery_indexTw.vue';
import gallery_describe from '../pages/gallery/gallery_describe.vue';
import story_index from '../pages/story/story_index.vue';
import story_dec from '../pages/story/story_dec.vue';
import chart_index from '../pages/chart/chart_index.vue';
import chart_up from '../pages/chart/chart_up.vue';
import thanks from '../pages/thanks/thanks.vue';
import copyright from '../pages/copyright/copyright.vue';

const routes = [{
	path: '/',
	component: Index,
	name: 'Index',
}, {
	path: '/galleryIndex',
	name: 'galleryIndex',
	component: galleryIndex,
}, {
	path: '/galleryDec',
	name: 'galleryDec',
	component: galleryDec
}, {
	path: '/gallery_indexTw',
	component: gallery_indexTw,
	name: 'gallery_indexTw',
}, {
	path: '/gallery_decTw',
	component: gallery_decTw,
	name: 'gallery_decTw',
}, {
	path: '/gallery_describe',
	component: gallery_describe,
	name: 'gallery_describe',
}, {
	path: '/story_index',
	component: story_index,
	name: 'story_index',
}, {
	path: '/story_dec',
	name: 'story_dec',
	component: story_dec
}, {
	path: '/chart_index',
	component: chart_index,
	name: 'chart_index',
}, {
	path: '/chart_up',
	component: chart_up,
	name: 'chart_up',
}, {
	path: '/thanks',
	component: thanks,
	name: 'thanks',
}, {
	path: '/copyright',
	component: copyright,
	name: 'copyright',
}]

const router = new VueRouter({
	routes
})
export default router
